<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M16 7.99333C16 10.1151 15.1571 12.1499 13.6569 13.6502C12.1566 15.1505 10.1217 15.9933 8 15.9933C5.87827 15.9933 3.84344 15.1505 2.34315 13.6502C0.842858 12.1499 3.98209e-06 10.1151 3.98209e-06 7.99333C-0.000611702 7.38113 0.0701693 6.77095 0.210913 6.17515C0.622524 4.41825 1.61602 2.8521 3.03003 1.73108C4.44405 0.610053 6.19552 0 8 0C9.80448 0 11.556 0.610053 12.97 1.73108C14.384 2.8521 15.3775 4.41825 15.7891 6.17515C15.9298 6.77095 16.0006 7.38113 16 7.99333Z"
      fill="#7ACD96"
    />
    <path
      d="M11.1212 5.2979L6.54444 9.87463L4.8768 8.20699C4.73964 8.07451 4.55593 8.00121 4.36524 8.00287C4.17455 8.00452 3.99214 8.08101 3.8573 8.21585C3.72246 8.35069 3.64597 8.5331 3.64431 8.72379C3.64266 8.91448 3.71596 9.09819 3.84844 9.23536L6.03026 11.4172C6.16664 11.5535 6.35159 11.6301 6.54444 11.6301C6.73729 11.6301 6.92224 11.5535 7.05862 11.4172L12.1495 6.32627C12.282 6.1891 12.3553 6.00539 12.3537 5.8147C12.352 5.62401 12.2755 5.44161 12.1407 5.30676C12.0058 5.17192 11.8234 5.09543 11.6327 5.09378C11.442 5.09212 11.2583 5.16543 11.1212 5.2979Z"
      fill="#FBFBFB"
    />
  </svg>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "LoginVerifiedIcon",
});
</script>

<style scoped lang="scss"></style>
